import { INSTANCE_ROUTES } from '@localstack/constants';

import { InjectableViewProps, ResourceBrowserProps } from '../layout';

export type InstanceRoutes = Record<keyof typeof INSTANCE_ROUTES, string>;

export type InstanceViewProps = InjectableViewProps<InstanceRoutes>;

export type ResourceBrowserViewProps = ResourceBrowserProps<InstanceRoutes>;
